import axios from 'axios'
import pdf from 'vue-pdf'

export default class {
    _dowloadDocumentlUrl
    _pdf = null

    constructor() {
        this._dowloadDocumentlUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_DOWNLOAD_OPERATION}`
        this._pdf = pdf
        this._additionalConfig = {
            headers: {
            'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
            }
        }
    }

    downloadPDF(url){
        return this._pdf.createLoadingTask(url)
    }

    getPresignedDocument(id){
        return axios.get(`${this._dowloadDocumentlUrl}/${id}`)
    }

    getPresignedDocumentByToken(token){
        let additionalConfig = {
            headers: {
            'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`,
            'Authorization': `Bearer ${token}`
            }
        }
        
        return axios.get(`${this._dowloadDocumentlUrl}`, additionalConfig)
    }
}